/* Crop a baseline-sized photo without stretching it; keep live text outside the crop. */
(() => {
 if (customElements.get('carpiem-hero-crop')) return;
 class CarpiemHeroCrop extends HTMLElement {
  connectedCallback() {
   this.hero = this.closest('.shopify-section')?.querySelector('.carpiem-hero');
   this.media = this.hero?.querySelector('.carpiem-hero__media');
   this.copy = this.hero?.querySelector('.carpiem-hero__content');
   if (!this.hero || !this.media || !this.copy) return;
   this.query = window.matchMedia('(max-width: 749px)');
   this.queue = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.update(); });
   };
   this.query.addEventListener('change', this.queue);
   window.addEventListener('resize', this.queue, { passive: true });
   this.observer = new ResizeObserver(() => {
    if (this.signature() !== this.lastSignature) this.queue();
   });
   this.observer.observe(this.hero);
   this.observer.observe(this.copy);
   document.fonts?.ready.then(() => { if (this.isConnected) this.queue(); });
   this.update();
  }
  signature() {
   const a = this.hero.getBoundingClientRect(), b = this.copy.getBoundingClientRect();
   return [a.width, a.height, b.width, b.height].map(n => Math.round(n * 100) / 100).join(',');
  }
  update() {
   const mode = this.query.matches ? 'Mobile' : 'Desktop';
   let top = Math.max(0, Number(this.dataset['top' + mode]) || 0);
   let bottom = Math.max(0, Number(this.dataset['bottom' + mode]) || 0);
   // Remove only our state to measure the exact original layout at this viewport.
   this.hero.removeAttribute('data-cp3-crop-active');
   if (!top && !bottom) { this.lastSignature = this.signature(); return; }
   const heroBox = this.hero.getBoundingClientRect();
   const mediaBox = this.media.getBoundingClientRect();
   const copyBox = this.copy.getBoundingClientRect();
   if (!heroBox.height || !heroBox.width) { this.lastSignature = this.signature(); return; }
   const style = getComputedStyle(this.copy);
   const paddingTop = parseFloat(style.paddingTop) || 0;
   const paddingBottom = parseFloat(style.paddingBottom) || 0;
   // Text, margins and buttons set a safe floor. Excessive crops are reduced proportionally.
   const contentHeight = Math.max(0, copyBox.height - paddingTop - paddingBottom);
   const requested = top + bottom;
   const available = Math.max(0, heroBox.height - Math.max(1, contentHeight));
   const actual = Math.min(requested, available);
   if (requested > actual) { const scale = actual / requested; top *= scale; bottom *= scale; }
   const visibleHeight = heroBox.height - top - bottom;
   this.hero.style.setProperty('--cp3-visible-height', visibleHeight + 'px');
   this.hero.style.setProperty('--cp3-original-media-height', mediaBox.height + 'px');
   this.hero.style.setProperty('--cp3-media-top', (mediaBox.top - heroBox.top - top) + 'px');
   this.hero.style.setProperty('--cp3-content-bottom', Math.min(paddingBottom, Math.max(0, visibleHeight - contentHeight)) + 'px');
   this.hero.setAttribute('data-cp3-crop-active', '');
   this.lastSignature = this.signature();
  }
  disconnectedCallback() {
   if (this.frame) cancelAnimationFrame(this.frame);
   this.observer?.disconnect();
   this.query?.removeEventListener('change', this.queue);
   if (this.queue) window.removeEventListener('resize', this.queue);
   this.hero?.removeAttribute('data-cp3-crop-active');
  }
 }
 customElements.define('carpiem-hero-crop', CarpiemHeroCrop);
})();
